
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/loans",
      function () {
        return require("private-next-pages/products/loans/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/loans"])
      });
    }
  